export default "__VITE_ASSET__0af40d45__"